import { render, staticRenderFns } from "./CohortsClear.vue?vue&type=template&id=232f0f20&scoped=true"
import script from "./CohortsClear.vue?vue&type=script&lang=js"
export * from "./CohortsClear.vue?vue&type=script&lang=js"
import style0 from "./CohortsClear.vue?vue&type=style&index=0&id=232f0f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232f0f20",
  null
  
)

export default component.exports